module.exports = __webpack_public_path__ + "static/McRae-8c2f6feeb0f071a0e76f989a6388a1be.jpg";